<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/authorsnote">Author’s Note</a></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01"><span class="small">CHAPTER 1.</span> The Botched Hit</a></p>
<p class="toc"><a href="#/chapter02"><span class="small">CHAPTER 2.</span> Growing Up in Revere</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample"><span class="small">CHAPTER 3.</span> The Boston Underworld</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample"><span class="small">CHAPTER 4.</span> The Early Years</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample"><span class="small">CHAPTER 5.</span> Irish Gang War</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample"><span class="small">CHAPTER 6.</span> Mob War</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample"><span class="small">CHAPTER 7.</span> The Trial</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample"><span class="small">CHAPTER 8.</span> What’s Left</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4c59fa46